import React, { useEffect, useState } from 'react'
import { NavLink, useParams, useNavigate, Link } from 'react-router-dom'
import axios from 'axios'
import { Rating } from 'primereact/rating'
import {urlEncodeObject } from '../../utils/url-encode-object'

export const displayExperience = experience => {
    if (experience < 0) {
        return "inconue";
    }

    return experience + " ans";
}

export const getActivitesFromDetail = aoDetail => {
   
    if (!aoDetail ||  !aoDetail.value || !aoDetail.value.activites || !aoDetail.value.activites.length) {
        return "non trouvé"
    }


    var jointureActivites = ' et '
    if (aoDetail.value.conditionForActivite === "OR") {
        jointureActivites = ' ou '
    }


    if (aoDetail.value.activites.length === 1) {
        return aoDetail.value.activites[0].name
    }
    else {
        return aoDetail.value.activites.map(x => x.name).join(jointureActivites);
    }
}

export const getNiveauActiviteFromDetail = aoDetail => {
    if (!aoDetail || !aoDetail.value || !aoDetail.value.activites || !aoDetail.value.activites.length) {
        return <>non trouvé</>
    }

    let niveau = Math.max(...aoDetail.value.activites.map(x => x.niveau));

    if (niveau > 0) {
        return <Rating value={niveau} cancel={false} />
    }

    return <>inconnu</>
}


export const getExperienceFromDetail = aoDetail => {
    if (!aoDetail  || !aoDetail.value || !aoDetail.value.activites || !aoDetail.value.activites.length) {
        return "non trouvée";
    }
    else {
        var experience = aoDetail.value.activites[0].experience;

        if (typeof experience == "number") {

            if (experience === -1) {
                return "inconnue"
            }

            return experience + " ans";
        }
        else if (typeof experience == "object") {
            if (experience[1] === "+") {
                return experience[0] + " ans et +"
            }
            else {
                return "de " + experience[0] + " ans à " + experience[1] + " ans";
            }
        }

        return "inconnue";
    }
}

export const AOResumeComponent = ({ aoParsed, children})  => {

    const navigate = useNavigate();

    const getTitre = () => {
        if (aoParsed && aoParsed.value && aoParsed.value.titre) {
            return aoParsed.value.titre;
        }
        else {
            return "non trouvé";
        }
    }

    const getReference = () => {
        if (aoParsed && aoParsed.value && aoParsed.value.reference) {
            return aoParsed.value.reference;
        }
        else {
            return "non trouvé";
        }
    }

    const getLocalisation = () => {
        if (aoParsed && aoParsed.value && aoParsed.value.localisation) {
            return aoParsed.value.localisation;
        }
        else {
            return "non trouvé";
        }
    }

    const getClient = () => {
        if (aoParsed && aoParsed.value && aoParsed.value.client) {
            return aoParsed.value.client;
        }
        else {
            return "non trouvé";
        }
    }

    const onChangeAppelOffre = () => {

        if (aoParsed && aoParsed.value) {
            navigate("/aos/ondemand/" + urlEncodeObject(aoParsed.value));
        }
    }

    return <div className="d-flex flex-row alert alert-secondary" ><div className="flex-grow-1">
        Titre: {getTitre()} <br />
        Reference: {getReference()}<br />
        Client: {getClient()}<br />
        Localisation: {  getLocalisation()}<br/>
        Activité: {getActivitesFromDetail(aoParsed)} <br />
        Niveau: {getNiveauActiviteFromDetail(aoParsed)} <br />
        Expérience: {getExperienceFromDetail(aoParsed)} <br />
        <br />
        <div className="d-flex flex-row gap-5">
            { children }
        </div>
    </div>
        <div> <button className="btn btn-outline-primary" onClick={ onChangeAppelOffre }>Changer l'appel d'offre</button></div>

    </div>
}

export const AODetailComponent = ({ aoParsed, dontDisplayErrorAndWarning }) => {

    const [filterCompetence, setFilterCompetence] = useState();

    const getErrorList = () => {
        if (aoParsed && aoParsed.errors && aoParsed.errors.length > 0) {
            return aoParsed.errors.map((x, i) => <li key={i} className="list-group-item list-group-item-danger">{x}</li>)
        }
        else {
            return <></>
        }
    }

    const getWarningList = () => {
        if (aoParsed && aoParsed.warning && aoParsed.warning.length > 0) {
            return aoParsed.warning.map((x, i) => <li key={i} className="list-group-item list-group-item-warning">{x}</li>)
        }
        else {
            return <></>
        }
    }

    const numberOfErrors = () => {
        if (aoParsed && aoParsed.errors) {
            return aoParsed.errors.length
        }

        return 0
    }

    const numberOfwarnings = () => {
        if (aoParsed && aoParsed.warning) {
            return aoParsed.warning.length
        }

        return 0
    }

    const displayCompetence = (x, color = "secondary") => {

        let spanClass = "col-3 alert alert-" + color;

        if (x.niveau <= 0) {
            return <span key={x.nom} className={spanClass} >{x.nom} (niveau inconnu)</span>
        }
        else {
            return <span key={x.nom} className={spanClass}>{x.nom} <Rating value={x.niveau} cancel={false} /></span>
        }
    }

    const displayOnlyFilterCompetence = x => {
        if (!filterCompetence) {
            return true;
        }
        else {
            if (x.nom.startsWith(filterCompetence)) {
                return true;
            }
            else {
                return false;
            }
        }
    }

    const getCompetences = () => {
        if (aoParsed && aoParsed.value && aoParsed.value.competences) {

            if (aoParsed.value.competences.length === 0) {
                return <>pas de compétences calculées</>
            }

            return aoParsed.value.competences.filter(displayOnlyFilterCompetence).map(x => displayCompetence(x));
        }
        else {
            return <>parsing non effectué</>
        }
    }

    const getCompetencesSuggerees = () => {
        if (aoParsed && aoParsed.value && aoParsed.value.competencesSuggerees) {

            if (aoParsed.value.competencesSuggerees.length === 0) {
                return <>pas de compétences suggérées</>
            }

            return aoParsed.value.competencesSuggerees.filter(displayOnlyFilterCompetence).map(x => displayCompetence(x, "primary"));
        }
        else {
    return <>parsing non éffectué</>
}
    }

    const getCompetencesBloquantes = () => {
        if (aoParsed && aoParsed.value && aoParsed.value.competences && aoParsed.value.competencesBloquantes) {

            if (aoParsed.value.competencesBloquantes.length === 0) {
                return <>pas de compétences obligatoires</>
            }


            return aoParsed.value.competencesBloquantes.map(x => {
                const competence = aoParsed.value.competences.find(y => y.nom === x);

                if (competence) {
                    return displayCompetence(competence);
                }

                else {
                    return <></>
                }
            });
        }
        else {
            return <>parsing non éffectué</>
        }
    }

    const displayCompetenceCard = (header, getCompetence) => <div className="card my-5">
        <div className="card-header">{header}</div>
        <div className="card-body d-flex flex-row flex-wrap gap-4">
            {getCompetence()}
        </div>
    </div>

    return <>
        {(dontDisplayErrorAndWarning ? <></> :
            < div className="accordion alert" id="accordionErrorsAndWarnings">
        <div className="accordion-item" id="headingErrorsAndWarnings" ><h2 className="accordion-header">
            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseErrorAndWarnings" aria-expanded="true" aria-controls="collapseErrorAndWarnings">
                Erreurs & Warnings ( {numberOfErrors()} erreurs et {numberOfwarnings()} warnings)</button></h2>
            <div id="collapseErrorAndWarnings" className="accordion-collapse collapse show" aria-labelledby="headingErrorsAndWarnings" data-bs-parent="#accordionErrorsAndWarnings">
                <div className="accordion-body">
                    <ul className="list-group">
                        {getErrorList()}
                        {getWarningList()}
                    </ul>
                </div>
            </div>
        </div>
    </div >
    )}
        <div className="col-6 mb-3 input-group">
            <div className="input-group-prepend">
                <span className="input-group-text" id="basic-addon1"><i className="pi pi-search"></i></span>
            </div>
            <input type="text" value={filterCompetence} onChange={x => setFilterCompetence(x.target.value)} /> </div>
        {displayCompetenceCard('Compétences obligatoires', getCompetencesBloquantes)}
        {displayCompetenceCard('Compétences calculées', getCompetences)}
        {displayCompetenceCard('Compétences suggérées', getCompetencesSuggerees)}
    </>
}

export const GetAOComponent = () => {
    const { aoId } = useParams();
    const navigate = useNavigate();

    const [aoDetail, setAoDetail] = useState();

    useEffect(() => {
        axios.get('/api/aoget/detail?id=' + aoId)
            .then(response => {
                setAoDetail(response.data)
            });
    }, [aoId]);


    const goPreviousResult = () => {
        if (aoDetail.previousId) {
            navigate('/aos/ao/' + aoDetail.previousId);
        }
    }

    const goNextResult = () => {
        if (aoDetail.nextId) {
            navigate('/aos/ao/' + aoDetail.nextId);
        }
    }

    const goRun = () => {
        if (aoDetail.runId) {
            navigate("/aos/result/" + aoDetail.runId)
        }
    }

    let previousIcon = <></>;
    if (aoDetail && aoDetail.previousId) {
        previousIcon = <i className="pi pi-arrow-circle-left text-primary" onClick={goPreviousResult} ></i>
    }

    let nextIcon = <></>
    if (aoDetail && aoDetail.nextId) {
        nextIcon = <i className="pi pi-arrow-circle-right text-primary" onClick={goNextResult} ></i>
    }

    let homeIcon = <></>
    if (aoDetail && aoDetail.runId) {
       homeIcon  = <i className="pi pi-home text-primary" onClick={goRun} ></i>
    }

    let result = <></>

    if (!aoDetail || !aoDetail.id) {
        result = <div className="alert aler-danger">L'ao {aoId} n'existe pas, veuillez cliquer <NavLink to="/aos" >ici</NavLink> pour revenir à la liste des runs
            d'appels d'offres
        </div>
    }
    else {
        result =
        <div>
                <div className="row mb-2">
                    <div className="col">{ previousIcon }
                    </div>
                    <div className="col-4"></div>
                    <div className="col-2 text-center">{homeIcon}</div>
                    <div className="col-4"></div>
                    <div className="col">{nextIcon} </div>
                </div>
                <div>
                    <AOResumeComponent aoParsed={aoDetail.resultat}>
                            <Link to={"/aos/aohtml/" + aoDetail.id}>voir le texte l'appel d'offre</Link>
                        <Link to={"/aos/matched/" + aoDetail.id}>voir les profils matchés</Link>
                    </AOResumeComponent>
                    <AODetailComponent aoParsed={ aoDetail.resultat } />
                </div>
        </div>
    }



    return result;
}